import { InjectionToken } from '@angular/core';

export const SHOW_BUTTON = new InjectionToken<boolean>('showButton');
export const WIDGET_PREVIEW_MODE = new InjectionToken<boolean>('widgetPreviewMode');
